export default __webpack_public_path__ + "static/custom-domain-8f3f820dafffef1013b2955f65296c48.png";